export default __webpack_public_path__ + "static/map-cd171855fbc90f1fbd02cb637b6cd121.jpg";